import { useMemo } from 'react';
import type { Row } from 'react-table';

import type { EntityModel } from '../../../pages/Trafficking/TraffickingPage/modelConverters';

function useSelectedRowsToTop(rows: Row<EntityModel>[], selectedRowIds: Record<string, boolean>): Row<EntityModel>[] {
  return useMemo(() => {
    if (Object.keys(selectedRowIds).length === 0) return rows;

    const selected: Row<EntityModel>[] = [];
    const unselected: Row<EntityModel>[] = [];

    for (const row of rows) {
      if (selectedRowIds[row.id]) {
        selected.push(row);
      } else {
        unselected.push(row);
      }
    }

    return [...selected, ...unselected].map((row, i) => ({ ...row, index: i }));
  }, [rows, selectedRowIds]);
}

export default useSelectedRowsToTop;
